export default __webpack_public_path__ + "media/flags/bz-0bd5780a.svg";